
  <!-- New design content -->
  <business-header [isAuthenticated]="isAuthenticated"></business-header>
  <div class="body-container">
    <router-outlet></router-outlet>
  </div>
  <business-footer [isAuthenticated]="isAuthenticated"></business-footer>
